import React, { useEffect, useState, useRef } from 'react';
import { Spinner, Avatar } from '@chakra-ui/react';
import { getSubanchorInfo } from '../services/Wallet/subAnchorService';

const getRandomColor = () => {
  const colors = ['red.400', 'blue.400', 'green.400', 'teal.400', 'purple.400', 'orange.400'];
  return colors[Math.floor(Math.random() * colors.length)];
};

const InfoRow = ({ label, value }) => (
  <div className="mb-2">
    <p className="text-sm text-gray-600">{label}</p>
    <p className="font-semibold text-base">{value ?? 'N/A'}</p>
  </div>
);

const formatMobile = (v) => (v == null || v === '' ? 'N/A' : String(v));

const SubAnchorInfoCard = ({ anchorId, walletId, onEditClick, refreshTrigger }) => {
  const [info, setInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const fetchInFlightRef = useRef(null);

  useEffect(() => {
    if (!anchorId || !walletId) {
      setLoading(false);
      return;
    }
    const requestKey = `subanchor-info-${anchorId}-${walletId}-${refreshTrigger ?? 0}`;
    if (fetchInFlightRef.current === requestKey) return;
    fetchInFlightRef.current = requestKey;
    setLoading(true);

    const fetchInfo = async () => {
      try {
        const data = await getSubanchorInfo(anchorId, walletId);
        setInfo(data);
      } catch (err) {
        console.error('Failed to load subanchor info', err);
        setInfo(null);
      } finally {
        setLoading(false);
        fetchInFlightRef.current = null;
      }
    };

    fetchInfo();
  }, [anchorId, walletId, refreshTrigger]);

  if (loading) {
    return <Spinner size="lg" thickness="4px" color="blue.500" />;
  }

  if (!info) {
    return <div className="text-red-600">Failed to load subanchor information.</div>;
  }

  return (
    <div className="bg-[#F3F4F6] rounded-md mx-4 my-4 p-4 flex flex-col md:flex-row items-start md:items-center justify-evenly gap-6">
      <div className="flex-shrink-0">
        <Avatar
          name={info.code}
          boxSize="70px"
          bg={getRandomColor()}
          color="white"
          fontWeight="bold"
        />
      </div>

      <div className="flex flex-col sm:grid sm:grid-cols-2 md:grid-cols-3 gap-4 w-full">
        <InfoRow label="Code" value={info?.code} />
        <InfoRow label="Contact No." value={formatMobile(info?.mobile)} />
        <InfoRow label="Email" value={info?.email ?? 'N/A'} />
      </div>

      {onEditClick && (
        <button
          type="button"
          onClick={() =>
            onEditClick({
              code: info?.code ?? '',
              mobile: info?.mobile,
              email: info?.email ?? '',
            })
          }
          className="px-4 py-2 text-sm font-medium text-[#233B85] border border-[#233B85] rounded-md hover:bg-[#F0F6FE] transition-colors"
        >
          Edit
        </button>
      )}
    </div>
  );
};

export default SubAnchorInfoCard;
